import setFullstoryInfo from './fullstory';

export const initializeThirdPartyResources = (userInfo) => {
  setFullstoryInfo(userInfo);
};

export default initializeThirdPartyResources;
